import { Query } from "@feathersjs/feathers/lib";
import { add, endOfMonth, isAfter, startOfMonth } from "date-fns";
import { makeObservable } from "mobx";
import { RootStore, ItemStore } from ".";
import { Milestone } from "../models";
import { DataType, IMilestone } from "../types";
import { DataContainer } from "./dataContainer";


export class MilestoneStore extends ItemStore<Milestone, IMilestone, MilestoneStore.ContainerType> {

  constructor(readonly rootStore: RootStore) {
    super(rootStore, Milestone.create, DataType.Milestone, [DataType.Milestone]);

    makeObservable(this, {
    });
  }
  /*******************************************************************************************************************************************
   * DB Access
   ********************************************************************************************************************************************/
  protected setupStorage() {
    super.setupStorage();
    
    // Hold next 5 user milestones in the future
    let t = MilestoneStore.ContainerType.Next;
    this.storage[t] = 
      new DataContainer<{title: string, id: number, date: string}, {title: string, id: number, date: Date}>(
          this.getQueries[t], 
          this.service,
          { // Config
            paginate:    true,
            pageSize:    5,
            limited:     true,
            eventFilter: (d) => isAfter(new Date(d.date), new Date()),
            conversion:  (d: {title: string, id: number, date: string}) => ({id: Number(d.id), title: d.title, date: d.date && new Date(d.date)}),
            name: this.data_type + "." + t,
          }
      );
    this.storage[t].addEventCallbacks(this.eventCallBacks);
  }

  /*******************************************************************************************************************************************
   * Overwrites
   ********************************************************************************************************************************************/
  init() {
    super.init();
  }

  get getQueries(): {[name: string]: Query} {
    return {
      [MilestoneStore.ContainerType.Next]: {
        date:    {$gte: new Date().toISOString()},
        $sort:   {"date": 1},
        $limit:  this.overviewLimit,
        $select: ["title", "id", "date"],
      }
    }
  }

  loadRoom = () => {
    super.loadRoom();
    this.query = {room_id: this.rootStore.authStore.getCurRoomID};
  }

  loadDashboard = () => {
    super.loadDashboard();
    this.query = {
      "milestone.date": {
        $gte: add(startOfMonth(this.rootStore.spaceStore.curDate), {weeks: -1}).toISOString(),
        $lte: add(endOfMonth(this.rootStore.spaceStore.curDate),   {weeks:  1}).toISOString(),
      }
    };
    this.storage.next.load();
  }

  clearDashboard = () => {
    this.storage.next.clear();
  }

  /*******************************************************************************************************************************************
   * Getter 
   ********************************************************************************************************************************************/

  /*******************************************************************************************************************************************
   * Setter 
   ********************************************************************************************************************************************/

  /*******************************************************************************************************************************************
   * Actions
   ********************************************************************************************************************************************/
}

export namespace MilestoneStore {
  export enum ContainerType {
    Next = "next", // Next X of that item type for the dashboard. Does not apply to questions
  }
}